import { getAtpProviderNameFromProviderId, getinsideClinicName, getinsideClinicNameFromOutsideLocationId, getinsideClinicNameFromPracticeId } from "../../../lib/labels"

export default function ServicesPart({itemData, isOutside}) {

    return <>
        {!isOutside && <h4>Services</h4>}
        {isOutside && <h4>Outside Services</h4>}
        <table>
            <thead>
                <tr>
                    <td>Date Ordered</td>
                    <td>Class</td>
                    <td>Description</td>
                    <td>Clinic</td>
                    <td>Provider</td>
                    <td>Completed date</td>
                </tr>
            </thead>

            {!isOutside && <tbody>
                {itemData && itemData.filter(item => !item.is_outside_clinic).map(item => (
                    <tr key={item.id}>
                        <td>{item.date_ordered}</td>
                        <td>{item.class}</td>
                        <td>{item.description}</td>
                        <td>{getinsideClinicNameFromPracticeId(item.practice_id)}</td>
                        <td>{getAtpProviderNameFromProviderId(item.provider_id)}</td>
                        <td>{item.completed_date}</td>
                    </tr>
                ))}   
            </tbody>}


            {isOutside && <tbody>
                {itemData && itemData.filter(item => item.is_outside_clinic).map(item => (
                    <tr key={item.id}>
                        <td>{item.date_ordered}</td>
                        <td>{item.class}</td>
                        <td>{item.description}</td>
                        <td>{getinsideClinicNameFromOutsideLocationId(item.outside_location_id)}</td>
                        <td>{item.outside_provider}</td>
                        <td>{item.completed_date}</td>
                    </tr>
                ))}   
            </tbody>}

            
        </table>
    </>
}